import axios from 'axios';
import router from '../router' 
// import store from '@/store'
/**
 * 
 *@Title  AJAX请求封装工具
 *@Auth： 杨松
 * 
 * 
 */

//接口统一路径
const baseHost = '/helper';

export function ajax(config) {
    //1.创建实例
    const instance = axios.create({
        //主Host
        baseURL: baseHost,
        //超时时间
        timeout: 50000000
    });

    //2.拦截器
    //请求拦截
    instance.interceptors.request.use(config => {
        // console.log(config);
        //1.比如config中的一些信息不符合服务器要求
        
        //2.每次请求时都希望在界面中显示请求图标
        // store.dispatch('updateloadding',true);

        //3.某些网络请求 比如登录 必须携带特殊信息 token 
        return config;
    }, err => {
        console.error('错误')
        console.error(err);
    });

    //响应拦截
    instance.interceptors.response.use(res => {
        // console.log('响应')
        // console.log(res)
        // store.dispatch('updateloadding',false);
        return res;
    }, err => {
        console.error('错误')
        console.error(err.response.status);
        router.replace({name:'Error'})
        // store.dispatch('updateloadding',false);
        return err;
    });


    //3.发送请求
    return instance(config);
}

